export const DROPDOWN_ALL_TEXT = 'common.All';
export const DROPDOWN_ALL_VALUE = '';
